import React, { useCallback, useEffect, useRef, useState } from "react";

import { getSector } from "helper";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import { Card, Grid } from "@mui/material";
import SearchBar from "components/SearchBar";
import CustomTable from "components/CustomTable";
import { _postApi } from "redux/action/api";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import { _fetchApi } from "redux/action/api";
import Scrollbar from "components/Tree/Scrollbar";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Badge,
  Alert,
  Col,
  ButtonGroup,
} from "reactstrap";
import { formatNumber } from "redux/action/api";
import CustomTypeahead from "components/CustomTypeahead";

import { year } from "helper";
import { useSelector } from "react-redux";
import { useToasts } from "helper/ToastAdapter";
import { useYear } from "useYearList";
import BudgetForm from "./BudgetForm";
import { BiTrash } from "react-icons/bi";
import { Edit } from "@mui/icons-material";
import ProposalTable from "./ProposalTable";
import { getNextYear } from "./getBudgetYear";
import { getMDaType } from "helper";
import CommentModal from "./Comment";
import { ensureNumber } from "redux/action/api";
import moment from "moment";

function MOPB() {
  // const navigate = useNavigate();
  const years = useYear();
  const [loading, setLoading] = useState(false);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [form, setForm] = useState({
    budget_year: moment().format("YYYY"),
    economic_code: "",
    economic_description: "",
    program_code: "",
    program_description: "",
    function_code: "",
    function_description: "",
    fund_code: "",
    fund_description: "",
    geo_code: "",
    geo_description: "",
    budget_amount: "",
    actual_amount: "",
    budget_type: "",
    start_date: "",
    end_date: "",
    segment: "",
    // mda_name: "",
  });

  // useEffect(() => {
  //   getNextYear((data) => setForm((p) => ({ ...p, budget_year: data })));
  // }, []);

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const [modalOpen2, setModalOpen2] = useState(false);
  const toggleModal2 = () => {
    setModalOpen2(!modalOpen2);
  };
  const [editData, setEditData] = useState(null);

  const handleEditClick = (item) => {
    setEditData(item);
    toggleModal();
  };
  const [huh, setHuh] = useState();

  const handleEditClick2 = (item, type) => {
    setEditData(item);
    toggleModal2();
    setHuh(type);
  };

  const handleDoubleClick = (index, item) => {
    setEditingIndex(index);
    setEditData(item);
  };
  const handleInputBlur = () => {
    setEditingIndex(-1);
    handleEditClick2(editData);
    setHuh("submit");
  };

  const fields = [
    {
      title: "Project/ Receipt Description",
      custom: true,
      component: (item) => <div>{item.description}</div>,
      rowSpan: true,
    },
    {
      title: "Administrative",
      custom: true,
      component: (item) => item.admin_description,
      rowSpan: true,
      width: 100,
    },
    {
      title: "Admin Code",
      custom: true,
      component: (item) => item.admin_code,
      rowSpan: true,
    },
    {
      title: "Economic Description",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <a href="#" onClick={() => handleEditClick(item)}>
            {item.economic_description}
          </a>
        ) : (
          item.economic_description
        ),
      rowSpan: true,
    },
    {
      title: "Economic Code",
      custom: true,
      component: (item) => <div>{item.economic_code}</div>,
      rowSpan: true,
    },
    {
      title: "Program Description",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <div onClick={() => handleEditClick(item)}>
            {item.program_description}
          </div>
        ) : (
          item.program_description
        ),
      rowSpan: true,
    },
    {
      title: "Functional Description",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <div onClick={() => handleEditClick(item)}>
            {item.function_description}
          </div>
        ) : (
          item.function_description
        ),
      rowSpan: true,
    },
    {
      title: "Functional Code",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <div onClick={() => handleEditClick(item)}>{item.function_code}</div>
        ) : (
          item.function_code
        ),
      rowSpan: true,
    },
    {
      title: "Geo Description",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <div onClick={() => handleEditClick(item)}>
            {item.geo_description}
          </div>
        ) : (
          item.geo_description
        ),
      rowSpan: true,
    },
    {
      title: "Geo Code",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <div onClick={() => handleEditClick(item)}>{item.geo_code}</div>
        ) : (
          item.geo_code
        ),
      rowSpan: true,
    },
    {
      title: "Fund Description",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <div onClick={() => handleEditClick(item)}>
            {item.fund_description}
          </div>
        ) : (
          item.fund_description
        ),
    },
    {
      title: "Fund Code",
      custom: true,
      component: (item) =>
        item.status === "final-proposal" ? (
          <div onClick={() => handleEditClick(item)}>{item.fund_code}</div>
        ) : (
          item.fund_code
        ),
    },
    {
      title: "Fund Amount",
      custom: true,
      component: (item) => (
        <div style={{ textAlign: "right" }}>{formatNumber(item.fund_amt1)}</div>
      ),
    },

    {
      title: "Proposed Amount(₦)",
      custom: true,
      component: (item) => (
        <div style={{ float: "right" }}>{formatNumber(item.budget_amount)}</div>
      ),
      rowSpan: true,
    },
    {
      title: "MOPB Adjustments(₦)",
      custom: true,
      component: (item, idx) => (
        <div
          onDoubleClick={() => handleDoubleClick(idx, item)}
          style={{ float: "right" }}
        >
          {item.status === "final-proposal" &&
            item.type_of_budget != "Capital" ? (
            editingIndex === idx ? (
              <Input
                name="mopb_amount"
                value={item.mopb_amount || item.budget_amount}
                onChange={({ target: { value } }) => handleChanges(value, idx)}
                onBlur={handleInputBlur}
                style={{ width: "120px", textAlign: "right" }}
              />
            ) : (
              formatNumber(item.mopb_amount || item.budget_amount)
            )
          ) : (
            formatNumber(item.mopb_amount)
          )}
        </div>
      ),
      rowSpan: true,
    },

    {
      title: "Action",
      custom: true,
      width: 200,
      component: (item) => (
        <div className="text-center d-flex flex-direction-row justify-content-between">
          {/* <button
            disabled={item.status === "draft" ? false : true}
            className="btn btn-danger btn-sm"
            color="primary"
            onClick={() => handleDelete(item.id)}
          >
            <BiTrash />
          </button> */}
          <Button
            // disabled={item.status === "draft" ? false : true}
            color="primary"
            onClick={() => handleEditClick2(item, "edit")}
            size="sm"
          >
            Show Comment
          </Button>
        </div>
      ),
      rowSpan: true,
    },
    // {
    //   title: "Exco Adjustment",
    //   custom: true,
    //   component: (item) => (
    //     <div style={{ float: "right" }}>
    //       {formatNumber(parseFloat(item.mopb_amount - item.exco_amount))}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Action",
    //   custom: true,
    //   component: (item) => (
    //     <div className="text-center">
    //       <button
    //         className="btn btn-primary"
    //         color="primary"
    //         onClick={() => handleSubmit(item)}
    //       >
    //         Submit
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  const [results, setResults] = useState();
  // let data = results&&results.map(item => item.name)
  const [results4, setResult4] = useState([]);
  useEffect(() => {
    getSector({ type: "mdas" }, "mdas", (d) => {
      setResult4(d);
    });
  }, []);

  const handleChange = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const [budget, setBudget] = useState([]);
  const getBudgetType = () => {
    // setLoading(true);
    _fetchApi(
      `/get-budget-new/null?query_type=type&budget_type=${form.type}&budget_year=${form.year}`,
      (res) => {
        setBudget(res.results);
        setLoading(false);
      },
      (err) => console.log(err)
    );
  };
  useEffect(() => {
    getBudgetType();
  }, [form.type]);

  let newBudget = { type_of_budget: "All" };
  let isObjectExists = budget?.some(
    (item) => item.type_of_budget === newBudget.type_of_budget
  );

  if (!isObjectExists) {
    budget?.push(newBudget);
  }
  const getBudgetNew = useCallback(() => {
    _fetchApi(
      `/get-budget-new/${form.mda_name}?query_type=mopb&budget_year=${form.budget_year}`,
      (res) => {
        const modifiedResults = res.results
          .map((item) => {
            if (!item.mopb_amount) {
              return { ...item, mopb_amount: item.budget_amount };
            }
            return item;
          })
          .filter((item) => item.status != "draft");
        setResults(modifiedResults);
      },
      (err) => {
        console.log(err);
      }
    );
  }, [form.mda_name, form.budget_year]);

  useEffect(() => {
    getBudgetNew();
  }, [getBudgetNew]);

  const handleChanges = (value, index) => {
    const arr = [...results];
    arr[index].mopb_amount = value;
    setResults(arr);
  };
  const { addToast } = useToasts();
  const [mda, setMda] = useState();
  const [rSelected, setRSelected] = useState(1);
  const [pastData, setPastData] = useState([]);

  const fetchProposeLength = useCallback(() => {
    getMDaType(
      { type: "final-proposal", sub_head: form.budget_year },
      form.budget_year,
      (d) => {
        setMda(d);
        // alert(JSON.stringify(d))
      },
      "type"
    );
  }, [form.budget_year]);

  const fetchPastProposeLength = useCallback(() => {
    getMDaType(
      { type: "", sub_head: form.budget_year },
      form.budget_year,
      (d) => {
        setPastData(d);
      },
      "mopb"
    );
  }, [form.budget_year]);

  const mdaRef = useRef(null);
  useEffect(() => {
    fetchProposeLength();
    fetchPastProposeLength();
  }, [fetchProposeLength, fetchPastProposeLength]);

  let aheadData99 = mda?.map((i) => ({
    head: `${i.head}-${i.description}(${i.line_item})`,
    description: i.description,
    code: i.head,
  }));
  const handleSubmit = (name = "") => {
    const filteredResults = results.filter(
      (item) => item.status === "final-proposal"
    );
    let type = name === "final-mopb" ? "UPDATE" : "INSERT";
    _postApi(
      `/post-budget?query_type=${type}&status=${name}`,
      name === "final-mopb" ? filteredResults : [form],
      (res) => {
        if (res.success) {
          fetchProposeLength();
          fetchPastProposeLength();
          addToast("Submitted Successfully", {
            appearance: "info",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          getBudgetNew();
          setResults([]);
        }
      },
      (err) => {
        console.log(err);
        // alert('An error occurred!');
      }
    );
  };
  let aheadData = pastData?.map((i) => ({
    head: `${i.head}-${i.description}`,
    description: i.description,
    code: i.head,
  }));

  const user = useSelector((e) => e.auth.user);
  const filteredResults1 = results?.filter((item) => {
    if (!form.status || form.status === "All") {
      return true;
    }
    return item.type_of_budget === form.status;
  });

  const filteredResults = results?.filter((item) => {
    if (!form.status || form.status === "All") {
      return item.status === "final-proposal";
    }
    return (
      item.status === "final-proposal" && item.type_of_budget === form.status
    );
  });

  const totalAmount =
    rSelected === 1
      ? filteredResults?.reduce(
        (total, item) => parseFloat(ensureNumber(item.budget_amount)) + total,
        0
      )
      : filteredResults1?.reduce(
        (total, item) => parseFloat(ensureNumber(item.mopb_amount)) + total,
        0
      );

  const [modal3, setModal3] = useState(false);
  const toggle3 = () => setModal3(!modal3);
  const repRef = useRef();
  const repRef1 = useRef();
  const repRef2 = useRef();
  const repRef3 = useRef();
  const repRef4 = useRef();
  const repRef5 = useRef();
  const [results6, setResults6] = useState([]);
  const [results1, setResults1] = useState([]);
  const [results2, setResults2] = useState([]);
  const [results3, setResults3] = useState([]);
  const [results9, setResults9] = useState([]);
  const [results5, setResults5] = useState([]);
  // let data = results&&results.map(item => item.name)
  useEffect(() => {
    getSector({ type: "ADMINISTRATIVE SEGMENT" }, "select", setResults6);
  }, []);

  useEffect(() => {
    getSector({ type: "ECONOMIC SEGMENT" }, "select", setResults1);
  }, []);

  useEffect(() => {
    getSector({ type: "FUNCTIONAL SEGMENT" }, "select", setResults2);
  }, []);

  useEffect(() => {
    getSector({ type: "PROGRAMME SEGMENT" }, "select", setResults3);
  }, []);

  useEffect(() => {
    getSector({ type: "FUND SEGMENT" }, "select", setResults9);
  }, []);

  useEffect(() => {
    getSector({ type: "GEO SEGMENT" }, "select", setResults5);
  }, []);

  let aheadData6 =
    results9 &&
    results9?.map((i) => ({
      head: `${i.head}-${i.description}`,
      description: i.description,
      code: i.head,
    }));
  let aheadData1 =
    results6 &&
    results6?.map((i) => ({
      head: `${i.head}-${i.description}`,
      description: i.description,
      code: i.head,
    }));
  let aheadData2 =
    results2 &&
    results2?.map((i) => ({
      head: `${i.head}-${i.description}`,
      description: i.description,
      code: i.head,
    }));
  let aheadData3 =
    results3 &&
    results3?.map((i) => ({
      head: `${i.head}-${i.description}`,
      description: i.description,
      code: i.head,
    }));
  let aheadData4 =
    results1 &&
    results1?.map((i) => ({
      head: `${i.head}-${i.description}`,
      description: i.description,
      code: i.head,
    }));
  let aheadData5 =
    results5 &&
    results5?.map((i) => ({
      head: `${i.head}-${i.description}`,
      description: i.description,
      code: i.head,
    }));
  const handleChanging = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleSave = (updatedItem) => {
    const updatedItems = results.map((item) =>
      item.id === updatedItem.id ? updatedItem : item
    );
    setResults(updatedItems);
    toggleModal();
  };

  const selectedResults = rSelected === 1 ? filteredResults : filteredResults1;

  const distinctResults = Array.from(
    new Map(
      selectedResults?.map((item) => [
        item.type_of_budget,
        { type_of_budget: item.type_of_budget },
      ])
    ).values()
  );
  return (
    <DashboardLayout>
      {form.mda_name && <center>{/* <h2>{form.budger_}</h2> */}</center>}
      <MDBox pt={1} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="success"
              >
                <MDTypography
                  variant="h5"
                  color="white"
                  className="text-center"
                >
                  MOPB Recommendation Page
                </MDTypography>
              </MDBox>

              {/* <div className="">
                {" "}
                <Button
                  color="primary"
                  className="pr-5 pl-5 m-4"
                  style={{ float: "right" }}
                  onClick={() => toggle3()}
                >
                  Add New Proposal
                </Button>
              </div> */}
              {/* {JSON.stringify(editingIndex)} */}
              <Modal isOpen={modal3} toggle={toggle3} size="lg">
                <ModalHeader>Continue With</ModalHeader>
                <ModalBody>
                  <div className=" row mb-4 p-3">
                    <div className="col-md-4 ">
                      <Label>Select budget year</Label>
                      <Input
                        type="select"
                        name="budget_year"
                        value={form.budget_year}
                        onChange={handleChange}
                      >
                        <option>--select--</option>
                        {years?.map((item) => (
                          <option key={item}>{item}</option>
                        ))}
                      </Input>
                    </div>
                    <div className="col-md-6">
                      <CustomTypeahead
                        ref={repRef}
                        labelKey="head"
                        label="Adminstrative Segment"
                        options={aheadData1}
                        onChange={(s) => {
                          if (s.length) {
                            setForm((p) => ({
                              ...p,
                              admin_code: s[0].code,
                              admin_description: s[0].description,
                              mda_name: s[0].description,
                            }));
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <CustomTypeahead
                        ref={repRef1}
                        labelKey="head"
                        label="Economic Segment"
                        options={aheadData4}
                        onChange={(s) => {
                          if (s.length) {
                            setForm((p) => ({
                              ...p,
                              economic_code: s[0].code,
                              economic_description: s[0].description,
                            }));
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <CustomTypeahead
                        ref={repRef2}
                        labelKey="head"
                        label="Fund Segment"
                        options={aheadData6}
                        onChange={(s) => {
                          if (s.length) {
                            setForm((p) => ({
                              ...p,
                              fund_code: s[0].code,
                              fund_description: s[0].description,
                            }));
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <CustomTypeahead
                        ref={repRef3}
                        labelKey="head"
                        label="Geo Segment"
                        options={aheadData5}
                        onChange={(s) => {
                          if (s.length) {
                            setForm((p) => ({
                              ...p,
                              geo_code: s[0].code,
                              geo_description: s[0].description,
                            }));
                          }
                        }}
                      />
                    </div>

                    <div className="col-md-6">
                      <CustomTypeahead
                        ref={repRef4}
                        labelKey="head"
                        label="Program Segment"
                        options={aheadData3}
                        onChange={(s) => {
                          if (s.length) {
                            setForm((p) => ({
                              ...p,
                              program_code: s[0].code,
                              program_description: s[0].description,
                            }));
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6">
                      <CustomTypeahead
                        ref={repRef5}
                        labelKey="head"
                        label="Functional Segment"
                        options={aheadData2}
                        onChange={(s) => {
                          if (s.length) {
                            setForm((p) => ({
                              ...p,
                              function_code: s[0].code,
                              function_description: s[0].description,
                            }));
                          }
                        }}
                      />
                    </div>

                    <div className="col-md-6">
                      <lable>Proposed Amount</lable>
                      <input
                        className="form-control"
                        type="number"
                        maxLength="4"
                        name="budget_amount"
                        value={form.budget_amount}
                        onChange={handleChanging}
                      />
                    </div>
                  </div>
                  <center>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        handleSubmit("final-proposal");
                        toggle3();
                      }}
                      disabled={filteredResults?.length === 0 ? true : false}
                    // disabled={filteredResults?.length === 0 ? true : false}
                    >
                      Add
                    </button>
                  </center>
                </ModalBody>
              </Modal>
              <MDBox>
                <MDBox>
                  {editData && (
                    <BudgetForm
                      toggle={toggleModal}
                      toggle2={toggleModal2}
                      isOpen={modalOpen}
                      initialData={editData}
                      onSave={handleSave}
                      title={"MOPB Recommendation Form"}
                      names="mopb_amount"
                    />
                  )}

                  {editData && (
                    <CommentModal
                      toggle={toggleModal2}
                      isOpen={modalOpen2}
                      data={editData}
                      onSave={handleSave}
                      title={"MOPB Recommendation Form"}
                      names="mopb recommendations"
                      edit={huh}
                    />
                  )}

                  {/* {JSON.stringify(pastData)} */}

                  <div className=" row p-3">
                    <Col md={4} className="mt-4">
                      <ButtonGroup size="sm">
                        <Button
                          color="primary"
                          outline
                          onClick={() => {
                            setRSelected(1);
                            mdaRef?.current?.clear();
                            setForm({ budget_year: form.budget_year });
                          }}
                          active={rSelected === 1}
                          size="sm"
                        >
                          MDA Proposals
                          <Badge color="warning">{mda?.length}</Badge>
                        </Button>
                        <Button
                          color="primary"
                          outline
                          onClick={() => {
                            setRSelected(2);
                            mdaRef?.current?.clear();
                            setForm({ budget_year: form.budget_year });
                          }}
                          active={rSelected === 2}
                        >
                          MOPB Adjusted Proposals
                          <Badge color="warning">{pastData?.length}</Badge>
                        </Button>
                      </ButtonGroup>
                    </Col>

                    <div className="col-md-2 mb-3">
                      <CustomTypeahead
                        labelKey="type_of_budget"
                        label="Budget type"
                        options={distinctResults || []}
                        onChange={(selected) => {
                          setForm((p) => ({
                            ...p,
                            status: selected[0]?.type_of_budget || "",
                          }));
                        }}
                        defaultSelected={[{ type_of_budget: "All" }]}
                      />
                    </div>
                    <div className="col-md-2">
                      <Label>Select budget year</Label>
                      <Input
                        type="select"
                        name="budget_year"
                        value={form.budget_year}
                        onChange={handleChange}
                      >
                        <option>--select--</option>
                        {years?.map((item) => (
                          <option key={item}>{item}</option>
                        ))}
                      </Input>
                    </div>
                    {/* {JSON.stringify({ form: form.transaction_type })} */}

                    <div className="col-md-3" style={{ marginTop: "25px" }}>
                      <Button
                        color="primary"
                        className="pr-5 pl-5"
                        onClick={() => toggle3()}
                        style={{ marginRight: 5 }}
                      // disabled={filteredResults?.length === 0 ? true : false}
                      >
                        Add New Proposal
                      </Button>

                      <Button
                        color="primary"
                        className="pr-5 pl-5"
                        onClick={() => handleSubmit("final-mopb")}
                        disabled={filteredResults?.length === 0 ? true : false}
                      >
                        Submit
                      </Button>
                    </div>

                    <div className="col-md-4 " style={{ marginTop: -20 }}>
                      <CustomTypeahead
                        labelKey="head"
                        label="Select MDA"
                        ref={mdaRef}
                        options={rSelected === 1 ? aheadData99 : aheadData}
                        onChange={(s) => {
                          if (s.length) {
                            console.log(s);
                            setForm((p) => ({
                              ...p,
                              mda_code: s[0].code,
                              mda_name: s[0].description,
                            }));
                          }
                        }}
                      />
                    </div>

                    <div className="col-md-4" style={{ marginTop: 10 }}>
                      <SearchBar
                        placeholder="Search By code or description"
                      // filterText={searchText}
                      // onFilterTextChange={handleSearchChange}
                      />
                    </div>

                    <div className="col-md-1"></div>
                    <div
                      className="col-md-3 text-right mt-4"
                      style={{ textAlign: "right" }}
                    >
                      <span style={{ fontWeight: "bold", float: "right" }}>
                        TOTAL : ₦{totalAmount?.toLocaleString()}
                      </span>
                    </div>
                    {/* <h1>i am sub org</h1>  */}
                    <Scrollbar>
                      {/* {JSON.stringify(results[2]?.mopb_amount)} */}

                      <ProposalTable
                        fields={fields}
                        data={
                          rSelected === 1 ? filteredResults : filteredResults1
                        }
                        type="mopb"
                      />
                    </Scrollbar>
                    {/* <center>
                      <Button
                        color="primary"
                        className="pr-5 pl-5"
                        onClick={() => handleSubmit("final-mopb")}
                        disabled={filteredResults?.length === 0 ? true : false}
                      >
                        Submit
                      </Button>
                    </center> */}
                  </div>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MOPB;
